import { render, staticRenderFns } from "./BtnDistribuirContrato.vue?vue&type=template&id=491a213e"
import script from "./BtnDistribuirContrato.vue?vue&type=script&lang=js"
export * from "./BtnDistribuirContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports